import { motion } from "framer-motion";
import React, { useContext } from "react";
import { AnswerContext, EaseContext, WidthContext } from "../App";
import { State } from "./KlimaContent";

export type Question = {
  text: string;
  name: string;
  image?: string;
  options: {
    text: string;
    value: number;
  }[];
};

type Props = {
  currentQuesNum: number;
  setCurrentQuesNum: (num: number) => void;
  question: Question;
  setCurrentState: (state: State) => void;
};
export const QuestionContent: React.FC<Props> = (props) => {
  const { currentQuesNum, setCurrentQuesNum, question, setCurrentState } =
    props;
  const { text, name, options } = question;

  const { answer, setAnswer } = useContext(AnswerContext);

  const handleClick = (value: number) => {
    if (name === "carType" && value === 43.6) {
      setCurrentQuesNum(currentQuesNum + 2);
      setAnswer({ ...answer, [name]: value, carDistance: 5 });
    } else {
      setCurrentQuesNum(currentQuesNum + 1);
      setAnswer({ ...answer, [name]: value });
    }

    if (currentQuesNum === 6) {
      setCurrentState("result");
    }
    window.scrollTo(0, 0);
  };

  const width = useContext(WidthContext);
  const ease = useContext(EaseContext);

  return (
    <motion.div
      key={question.text}
      initial={{ opacity: 0, x: width }} // 初期状態
      animate={{ opacity: 1, x: 0 }} // マウント時
      exit={{ x: 20 }} // アンマウント時
      transition={{
        duration: 0.5,
        ease: ease,
      }}
      className="rounded-xl shadow-xl mx-2 my-8 md:px-6 py-10 bg-slate-50 px-2"
    >
      <h2 className="text-center text-2xl font-semibold">
        <span className="mr-2">{currentQuesNum + 1}.</span>
        {text}
      </h2>
      <div className="flex justify-center pt-4 pb-6">
        {question.image ? (
          <img src={question.image} alt="welcome" className="h-36 max-w-full" />
        ) : (
          <img src="/images/welcome.png" alt="welcome" className="h-36" />
        )}
      </div>
      <div>
        <ul className="flex flex-wrap justify-center">
          {options.map((option) => {
            return (
              <li className="w-full px-4" key={option.value}>
                <button
                  type="button"
                  className="btn btn-primary btn-sm text-sm px-3 h-[40px] min-h-[0px] w-full mb-[8px] normal-case text-slate-50"
                  onClick={() => handleClick(option.value)}
                >
                  {option.text}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </motion.div>
  );
};
